<template>
  <router-view />
</template>

<script setup>
import useAppStore from '@/shared/store/useAppStore'
import storage, { Dynamic_System } from '@shared/utils/storage'

const appStore = useAppStore()

window.oncontextmenu = (e) => {
  e.preventDefault()
  return false
}

watch(
  () => appStore.dynamicSystemList.size,
  () => {
    storage.setItem(Dynamic_System, JSON.stringify([...appStore.dynamicSystemList.entries()]))
  }
)
</script>

<style lang="scss">
@import '@shared/styles/reset.css';
@import '@shared/styles/index.scss';

/** 本项目通用样式写在这里 */
</style>
